import { Box, Card, Collapse, Stack } from '@mui/material';
import { Paths } from 'type-fest';

import { Typography, TextField, Switches, CardContent, CardHeader } from '@occc-app/design-system';
import { pluralize } from '@occc-app/lib/strings';

import { PushNotificationConfig } from '../../common/push-notification-config.schema';
import { EngagementChannelConfigFormValues } from '../../common/engagement-channel-config.schema';

type PushConfigurationProps = {
  values?: PushNotificationConfig;
};

export const PushConfiguration = ({ values }: PushConfigurationProps) => {
  const notificationTitleLength = (values?.isEnabled && values?.notificationTitle?.length) || 0;
  const notificationBodyLength = (values?.isEnabled && values?.notificationBody?.length) || 0;

  return (
    <Card elevation={0}>
      <CardHeader
        title={
          <Typography variant='h6' component='p' gutterBottom>
            Send out Push
          </Typography>
        }
        action={
          <Switches
            name={
              'pushNotificationConfig.isEnabled' satisfies Paths<EngagementChannelConfigFormValues>
            }
            data={{}}
          />
        }
        sx={{ px: 0, py: 1 }}
      />
      <Collapse in={values?.isEnabled} timeout='auto' unmountOnExit>
        <CardContent sx={{ px: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Stack spacing={1}>
            <Box>
              <TextField
                label='Title'
                multiline
                name={
                  'pushNotificationConfig.notificationTitle' satisfies Paths<EngagementChannelConfigFormValues>
                }
              />
              <Typography textAlign='right' color='text.main' pt={0.5}>
                {notificationTitleLength}&nbsp;
                <Typography component='span' color='text.secondary'>
                  {pluralize(notificationTitleLength, 'character')}
                </Typography>
              </Typography>
            </Box>
            <Box>
              <TextField
                label='Body'
                multiline
                name={
                  'pushNotificationConfig.notificationBody' satisfies Paths<EngagementChannelConfigFormValues>
                }
              />
              <Typography textAlign='right' color='text.main' pt={0.5}>
                {notificationBodyLength}&nbsp;
                <Typography component='span' color='text.secondary'>
                  {pluralize(notificationBodyLength, 'character')}
                </Typography>
              </Typography>
            </Box>

            <TextField
              placeholder='Enter deeplink URL here'
              label='Deeplink'
              multiline
              name={'pushNotificationConfig.url' satisfies Paths<EngagementChannelConfigFormValues>}
            />
          </Stack>
        </CardContent>
      </Collapse>
    </Card>
  );
};
